<template>
  <img
    @click="$emit('click')"
    class="force-scan"
    :class="{ 'top-left': fixed }"
    :src="brandAsset(startScan, startScanSanne)"
    alt="Scan"
  />
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import startScan from '@/assets/common/start-scan.svg';
import startScanSanne from '@/assets/sanne/icons/force-scan.svg';

export default {
  name: 'ForceScan',
  mixins: [brandMode],
  data: () => ({ startScan, startScanSanne }),
  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.force-scan {
  @apply cursor-pointer;
  &.top-left {
    @apply fixed top-0 left-0 mt-10 ml-12;
    @screen xs {
      @apply ml-5;
      max-width: 30px;
      margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
      margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
    }
  }
}
</style>
